import dedent from 'dedent';

class Email {
  /**
   * Beware of some experimental syntax.
   * dedent is a library that removes leading and
   * trailing whitespaces from template strings.
   *
   * Nothing about this file is beautiful, but it works...
   */
  constructor() {
    this.subject = '';
    this.toAddress = '';
    this.template = '';
  }

  contact(message) {
    this.subject = 'QuickLegal - contact us';
    this.toAddress = 'qlegal@jmlrose.com.au';
    this.template = message;
  }

  contactConfirmation(email, message) {
    this.subject = 'QuickLegal - contact us';
    this.toAddress = email;
    this.template = dedent`
      Moments ago, you sent a message to QuickLegal, powered by JML ROSE | AN INCORPORATED LEGAL PRACTICE.

      If appropriate, we intend to respond to your message within two business days. If your matter is urgent, please call 1300 QLEGAL.

      For your records, a copy of your message appears immediately below.

      ${message}
    `;
  }

  lead(formData, forWho) {
    this.subject = `Lead ${formData.name}`;
    this.toAddress = 'leads@jmlrose.com.au';
    this.template = dedent`
      CONTACT INFO
      Name: ${formData.name}
      Email: ${formData.email}
      Phone: ${formData.phone}
      ${forWho === 'other' ? dedent`
        Representing: ${formData.whoseBehalf}
        Role/Position: ${formData.relationshipWithPerson}`
      : ''}
    `;
  }

  application(formData) {
    this.subject = `QuickLegal - new enquiry ${formData.step9.receiptNumber}`;
    this.toAddress = 'qlegal@jmlrose.com.au';
    this.template = dedent`
      CONTACT INFO
      Name: ${formData.step1.name}
      Email: ${formData.step1.email}
      Phone: ${formData.step1.phone}
      ${formData.forWho === 'other' ? dedent`
        Representing: ${formData.step1.whoseBehalf}
        Role/Position: ${formData.step1.relationshipWithPerson}`
      : ''}

      COURT PROCEEDINGS
      Currently involved in court proceedings: ${formData.step2.courtProceedingsOption}
      ${formData.step2.courtProceedingsOption === 'Yes' ? dedent`
        Court name: ${formData.step2.courtName}
        Proceedings number: ${formData.step2.proceedingsNumber}
        Other party representatives: ${formData.step2.whoRepresentsOtherParty}
        Your party: ${formData.step2.partyOption !== 'Other' ? formData.step2.partyOption : formData.step2.otherPartyField}`
      : ''}
      ${formData.step2.courtProceedingsOption === 'Maybe' ? dedent`
        How likely is it: ${formData.step2.courtLikelyhoodOption}
        When might court proceedings commence: ${formData.step2.courtCommencingOption}`
      : ''}

      MATTERS
      ${formData.step3.selectedMatters !== undefined && formData.step3.selectedMatters.map(matter => matter.title).join('\n')}

      QUESTION
      ${formData.step4.question}

      DOCUMENTS
      ${formData.documents !== undefined && formData.documents.length > 0
        ? formData.documents.map((doc, i) => dedent`
            Document #${i + 1}
            Filename: ${doc.fileName}
            Document Url: ${doc.file}
            Document date: ${doc.documentDate}
            Description: ${doc.description}
            Author: ${doc.author}
            Relevance of the document: ${doc.relevance}
            How was the document received: ${doc.received}
          `).join('\n\n')
        : 'None attached'}

      CHRONOLOGY CALENDAR
      ${formData.step6.events !== undefined && formData.step6.events.length > 0
        ? formData.step6.events.sort((a, b) => a.date - b.date).map((event, i) => dedent`
            Event #${i + 1}
            Date: ${new Date(event.date).toDateString()}
            Title: ${event.title}
            Description: ${event.description}
            Documents: ${event.documents.length === 0
              ? 'None attached'
              : event.documents.map(doc => `${doc.fileName}`).join(', ')}
          `).join('\n\n')
        : 'None attached'}

      VIDEO CONFERENCE PREFERENCES
      ${formData.step7.preferences !== undefined && formData.step7.preferences.length > 0
        ? formData.step7.preferences.map((pref, i) => dedent`
            Preference #${i + 1}
            Date: ${new Date(pref.date).toDateString()}
            Between ${pref.between} and ${pref.and}
          `).join('\n\n')
        : 'None attached'}

      PAYMENT ID
      ${formData.step9.receiptNumber}
    `;
  }

  applicationConfirmation(formData) {
    this.subject = `QuickLegal - your enquiry ${formData.step9.receiptNumber}`;
    this.toAddress = formData.step1.email;
    this.template = dedent`
      We confirm receipt of your enquiry with QuickLegal, powered by JML ROSE | AN INCORPORATED LEGAL PRACTICE.

      Please retain a copy of this email and read it carefully.

      Your reference is: ${formData.step9.receiptNumber}. Please ensure that this reference appears in the subject of any emails you send to us in respect of your enquiry - or alternatively, please be ready to quote this reference number, if you telephone 1300 QLEGAL.

      For your records, the information that you completed in your QuickLegal enquiry, appears at the bottom of this email. Please email us, if - between now and your video conference - you want to add more documents or change any information in your enquiry.

      Please note, any documents that you have uploaded with your enquiry, appear as hyperlinks in the record of your enquiry that appears below. These links will remain active for seven days only, and thereafter no access will be available to the uploaded documents. This is to best ensure the security of what might be sensitive or confidential information.

      You have said that you are available at the following times for your video conference:

      ${formData.step7.preferences !== undefined && formData.step7.preferences.length > 0
        ? formData.step7.preferences.map((pref, i) => dedent`
            Preference #${i + 1}
            Date: ${new Date(pref.date).toDateString()}
            Between ${pref.between} and ${pref.and}
          `).join('\n\n')
        : 'None attached'}

      What happens next

      1. We will review your enquiry and will send you email confirmation of the date and time for the video conference.

      2. If applicable, when we send you email confirmation of the video conference, we will - for the purpose of assisting your preparation for the video conference - identify categories of potentially relevant documents or information that might relate to your enquiry, but which you have not provided to us.

      3. Please remember, between now and the video conference, you are able to email us any additional documents or events in your chronology that you missed while completing your enquiry. Our preference is for you to do this by replying to this email.
      *NB: If, at any stage, your enquiry plus your uploaded documents exceed 10,000 words, you will be charged $165 (including GST) for every additional 2,000 words or part thereof.

      WHAT APPEARS IMMEDIATELY BELOW IS A SUMMARY OF THE INFORMATION INCLUDED IN YOUR ENQUIRY ${formData.step9.receiptNumber}

      CONTACT INFO
      Name: ${formData.step1.name}
      Email: ${formData.step1.email}
      Phone: ${formData.step1.phone}
      ${formData.forWho === 'other' ? dedent`
        Representing: ${formData.step1.whoseBehalf}
        Role/Position: ${formData.step1.relationshipWithPerson}`
      : ''}

      COURT PROCEEDINGS
      Currently involved in court proceedings: ${formData.step2.courtProceedingsOption}
      ${formData.step2.courtProceedingsOption === 'Yes' ? dedent`
        Court name: ${formData.step2.courtName}
        Proceedings number: ${formData.step2.proceedingsNumber}
        Other party representatives: ${formData.step2.whoRepresentsOtherParty}
        Your party: ${formData.step2.partyOption !== 'Other' ? formData.step2.partyOption : formData.step2.otherPartyField}`
      : ''}
      ${formData.step2.courtProceedingsOption === 'Maybe' ? dedent`
        How likely is it: ${formData.step2.courtLikelyhoodOption}
        When might court proceedings commence: ${formData.step2.courtCommencingOption}`
      : ''}

      MATTERS
      ${formData.step3.selectedMatters !== undefined && formData.step3.selectedMatters.map(matter => matter.title).join('\n')}

      QUESTION
      ${formData.step4.question}

      DOCUMENTS
      ${formData.documents !== undefined && formData.documents.length > 0
        ? formData.documents.map((doc, i) => dedent`
            Document #${i + 1}
            Filename: ${doc.fileName}
            Document Url: ${doc.file}
            Document date: ${doc.documentDate}
            Description: ${doc.description}
            Author: ${doc.author}
            Relevance of the document: ${doc.relevance}
            How was the document received: ${doc.received}
          `).join('\n\n')
        : 'None attached'}

      CHRONOLOGY CALENDAR
      ${formData.step6.events !== undefined && formData.step6.events.length > 0
        ? formData.step6.events.sort((a, b) => a.date - b.date).map((event, i) => dedent`
            Event #${i + 1}
            Date: ${new Date(event.date).toDateString()}
            Title: ${event.title}
            Description: ${event.description}
            Documents: ${event.documents.length === 0
              ? 'None attached'
              : event.documents.map(doc => `${doc.fileName}`).join(', ')}
          `).join('\n\n')
        : 'None attached'}
    `;
  }
}

export default new Email();



// WEBPACK FOOTER //
// ./src/services/email.js